<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <!-- <h3 class="title">回忆列表</h3> -->
            <div style="padding: 16px 32px 16px 0px">
              <span class="title">回忆列表</span>
              <el-button type="primary" size="small" style="float: right" @click="addWishes()">新建</el-button>
            </div>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="data_list">
                <el-table-column prop="id" label="编号" min-width="1"></el-table-column>
                <el-table-column prop="student_no" label="学号" min-width="2"></el-table-column>
                <el-table-column prop="name" label="校友姓名" min-width="2"></el-table-column>
                <el-table-column prop="is_pass_cn" label="状态" min-width="1"></el-table-column>
                <el-table-column prop="update_time" label="提交时间" min-width="3" sortable></el-table-column>
                <el-table-column prop="operating" label="操作" min-width="2" align="left">
                  <template slot-scope="scope">
                    <el-button class="operateText" size="mini" type="text" @click="wishesEdit(scope.row)">编辑</el-button>
                    <el-button class="operateText" size="mini" type="text" @click="wishesDelete(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :key="elementui_page_key"
                class="elPagination"
                background
                layout="prev, pager, next"
                :page-size="pageMaxSize"
                :page-count="pageCount"
                :current-page="currentPage"
                @current-change="currentChange"
              ></el-pagination>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      data_list: [], //数据列表
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 0
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.getList()
    },
    // 获取列表
    getList: function () {
      this.$api
        .wishesList({
          token: localStorage.getItem('token'),
          page: this.currentPage,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            info.status = info.status.cn
            info.create_time = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 排序
    changeTableSort(column) {
      this.order = StrUtils.getPropOrder(column)
      this.getList()
    },
    // 新建回忆
    addWishes() {
      this.$router.push({
        path: '/wxapp/wishes_add'
      })
    },
    // 编辑回忆
    wishesEdit(row) {
      this.$router.push({
        path: '/wxapp/wishes_add',
        query: {
          id: row.id
        }
      })
    },
    // 删除回忆
    wishesDelete(row) {
      this.$confirm('是否删除此回忆?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .wishesDel({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/wishes.vue